import type { AiComponentDto } from '@terra/shared-contracts-ai-applications';

export type AiComponentVerificationBadgeKey =
  | 'code'
  | 'verified'
  | 'contradicted'
  | 'suppressed'
  | 'unverified';

export type AiComponentCodeCoverageFilter = '' | 'backed' | 'missing';

export function isAiComponentProvenByCode({
  component,
}: {
  component: AiComponentDto;
}): boolean {
  return (
    component.verificationStatus === 'CODE_ONLY' ||
    component.provenance === 'CODE' ||
    component.provenance === 'HYBRID' ||
    component.aiFlowGraphId != null ||
    component.sources.includes('SOURCE_CODE')
  );
}

export function resolveAiComponentVerificationBadge({
  component,
}: {
  component: AiComponentDto;
}): AiComponentVerificationBadgeKey {
  if (component.verificationStatus === 'SUPPRESSED') {
    return 'suppressed';
  }

  if (component.verificationStatus === 'CONTRADICTED') {
    return 'contradicted';
  }

  if (component.verificationStatus === 'FAILED') {
    return 'unverified';
  }

  if (component.verificationStatus === 'RUNTIME_VERIFIED') {
    return 'verified';
  }

  if (isAiComponentProvenByCode({ component })) {
    return 'code';
  }

  return 'unverified';
}

export function isAiComponentVisibleInAssets({
  component,
  codeCoverageFilter,
  includeSuppressed = false,
}: {
  component: AiComponentDto;
  codeCoverageFilter: AiComponentCodeCoverageFilter;
  includeSuppressed?: boolean;
}): boolean {
  if (component.verificationStatus === 'SUPPRESSED' && !includeSuppressed) {
    return false;
  }

  if (!codeCoverageFilter) {
    return true;
  }

  const provenByCode = isAiComponentProvenByCode({ component });

  return codeCoverageFilter === 'missing' ? !provenByCode : provenByCode;
}
